import _ from "lodash";
import request, { convertServerErrors } from "../config";

export const isFormSubmitting = (key, state) => (state[key] ? !!state[key].isSubmitting : false);
export const getData = (key, state) => key.split(".").reduce((a, b) => a[b] || {}, state);

const SET_FORM_VALUE = "SET_FORM_VALUE";
const SET_FORM_ELEMENT_ATTRIBUTE = "SET_FORM_ELEMENT_ATTRIBUTE";
const SUBMIT_FORM = "SUBMIT_FORM";
const SUBMIT_FORM_SUCCESS = "SUBMIT_FORM_SUCCESS";
const SUBMIT_FORM_FAIL = "SUBMIT_FORM_FAIL";
const SET_FIELDS_WITH_ERRORS = "SET_FIELDS_WITH_ERRORS";

const INIT_EMPTY_FORM_STATE = "INIT_EMPTY_FORM_STATE";
const SET_DEFAULT_VALUES = "SET_DEFAULT_VALUES";

const SET_ERRORS_ON_FORM = "SET_ERRORS_ON_FORM";
const CLEAR_ERRORS_ON_FORM = "CLEAR_ERRORS_ON_FORM";
const RESET_FORM_STATUS = "RESET_FORM_STATUS";

const initialState = {
  login: { values: {} },
  verifyOTP: { values: {} },
  addETLive: { values: {}, originalValues: {} },

  addDomain: {
    values: {
      max_email_accounts: -1,
      max_email_accounts_archive: 0,
      max_email_quota: 8589934592,
      pop_disabled: false,
      smtp_disabled: false,
      imap_disabled: false,
      webmail_disabled: false,
      archive_disabled: false,
      catch_all_enabled: false
    }
  },

  addEmailAccount: {
    isPristine: true,
    values: {
      // pop_disabled: false,
      // smtp_disabled: false,
      // imap_disabled: false,
      // webmail_disabled: false,
      // archive_disabled: false
    }
  },

  updateEmailAccountPassword: { values: {} },
  updateEmailAccountLimits: { values: {}, originalValues: {} },
  updateEmailAccountAutoresponder: {
    values: {
      enabled_during_interval: false
    },
    originalValues: {}
  },
  ownershipCheckEmailVerification: { values: {}, originalValues: {} },
  ownershipCheckCodeVerification: { values: {}, originalValues: {} },
  updateDomainLimits: { values: {}, originalValues: {} },
  updateDomainServices: { values: {}, originalValues: {} },
  updateDomainSecurity: { values: {}, originalValues: {} },
  updateDomainAdvanced: { values: {}, originalValues: {} },
  signUp: { values: {}, originalValues: {} },
  resetPassword: { values: {}, originalValues: {} },
  setPasswordAndLogin: { values: {}, originalValues: {} },
  addAliasDomain: { values: {}, originalValues: {} },
  updateAccountPanelSettings: { values: {}, originalValues: {} },
  updateNotificationsSettings: { values: {}, originalValues: {} },
  updateAccount: { values: {}, originalValues: {} },
  addImport: { values: {}, originalValues: {} },
  filterAudits: { values: {}, originalValues: {}, isPristine: true },
  addMainCustomization: { values: {}, originalValues: {} },
  addCustomization: { values: {}, originalValues: {} },
  updateCustomization: { values: {}, originalValues: {} },
  updateMainCustomization: { values: {}, originalValues: {} },

  addMigration: { values: {}, originalValues: {} },
  executeMigration: { values: {}, originalValues: {} },
  addMigrationOptionForm: { values: {}, originalValues: {} },
  updateMigrationForm: { values: {}, originalValues: {} },
  addOrder: { values: {}, originalValues: {} },

  addManager: {
    values: {
      max_domains: -1,
      max_email_accounts: -1,
      max_email_accounts_archive: 0,
      max_email_quota: 8589934592
    },
    originalValues: {}
  },

  updateManagerPassword: { values: {}, originalValues: {} },
  updateManagerLimits: { values: {}, originalValues: {} },
  updateManagerBasic: { values: {}, originalValues: {} },

  addAliasEmailAccount: {
    values: {
      destinations: ""
    },
    originalValues: {}
  },
  updateAliasDestinations: { values: {}, originalValues: {} },

  updateEmailAccountAdvanced: {
    values: {
      forwards: ""
    },
    originalValues: {}
  }
};

export default function(state = initialState, action = {}, initState = initialState) {
  switch (action.type) {
    case SUBMIT_FORM:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          isSubmitting: true
        }
      };

    case SUBMIT_FORM_SUCCESS:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          hasErrors: false,
          isSubmitting: false,
          errors: undefined,
          fieldsWithErrors: undefined,
          originalResponse: action.originalResponse,
          isPristine: true
        }
      };

    case SUBMIT_FORM_FAIL:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          hasErrors: true,
          isSubmitting: false,
          errors: action.errors,
          originalResponse: action.originalResponse
        }
      };

    case SET_FORM_ELEMENT_ATTRIBUTE:
      return {
        ...state,
        [action.formName]: {
          fieldsAttributes: {
            ...getData(`${action.formName}.fieldsAttributes`, state),
            [action.field]: {
              ...getData(`${action.formName}.fieldsAttributes.${action.field}`, state),
              [action.attribute]: action.value
            }
          }
        }
      };

    case SET_FORM_VALUE:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          values: {
            ...getData(`${action.formName}.values`, state),
            [action.field]: action.value
          },
          isPristine: false,
          originalValues: initState[action.formName] ? initState[action.formName].values : {}
        }
      };

    case SET_FIELDS_WITH_ERRORS:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          fieldsWithErrors: action.fieldsWithErrors
        }
      };

    case RESET_FORM_STATUS:
      return {
        ...state,
        [action.formName]: {
          ...initState[action.formName],
          isPristine: true
        }
      };

    case SET_ERRORS_ON_FORM:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          errors: action.errors
        }
      };

    case CLEAR_ERRORS_ON_FORM:
      return {
        ...state,
        [action.formName]: {
          ...state[action.formName],
          errors: [],
          message: undefined
        }
      };

    case SET_DEFAULT_VALUES:
      let defaultFields = {};
      // compose the {nameOfTheField: { value: valueOfTheField}}
      // structure
      _.each(action.defaultValues, (v, k) => {
        defaultFields[k] = { value: v };
      });

      return {
        ...state,
        [action.formName]: {
          ...initialState[action.formName],
          isPristine: false,
          fields: {
            ...state[action.formName].fields,
            ...defaultFields
          }
        }
      };

    default:
      return state;
  }
}

export function initEmptyFormState(formName) {
  return {
    type: INIT_EMPTY_FORM_STATE,
    formName
  };
}

export function setFormValue(formName, field, value) {
  return {
    type: SET_FORM_VALUE,
    formName,
    field,
    value
  };
}

export function setFormElementAttribute(formName, field, attribute, value) {
  return {
    type: SET_FORM_ELEMENT_ATTRIBUTE,
    formName,
    field,
    value,
    attribute
  };
}

export function setErrorsOnForm(formName, errors) {
  return {
    type: SET_ERRORS_ON_FORM,
    formName,
    errors
  };
}

export function clearErrorsOnForm(formName) {
  return {
    type: CLEAR_ERRORS_ON_FORM,
    formName
  };
}

export function resetFormStatus(formName) {
  return {
    type: RESET_FORM_STATUS,
    formName
  };
}

export function setDefaultValuesOn(formName, defaultValues) {
  return {
    type: SET_DEFAULT_VALUES,
    formName,
    defaultValues
  };
}

export function setFieldsWithErrors(formName, fieldsWithErrors) {
  return {
    type: SET_FIELDS_WITH_ERRORS,
    fieldsWithErrors,
    formName
  };
}

export function submitForm(data, url, method, formName) {
  return function(dispatch) {
    const config = {
      method,
      url,
      data
    };

    let loadingFunc = () => ({ type: SUBMIT_FORM, formName });
    dispatch(loadingFunc());

    let successFunc = originalResponse => ({
      type: SUBMIT_FORM_SUCCESS,
      formName,
      originalResponse
    });

    let errorFunc = (errors, originalResponse) => {
      return {
        type: SUBMIT_FORM_FAIL,
        errors,
        formName,
        originalResponse
      };
    };

    request(config).then(
      resp => {
        dispatch(successFunc(resp));
      },
      resp => {
        const status = resp.response.status;

        if (status === 422) {
          // validation failed
          dispatch(errorFunc(convertServerErrors(resp.response.data.errors), resp.response));
          return true;
        }

        if (status === 403) {
          // limits exceeded
          dispatch(errorFunc({ fake_field: resp.response.data.message }, resp.response));
          return true;
        }

        dispatch(errorFunc(resp.response.data && resp.response.data.errors, resp.response));

        if (typeof resp.response.data === "string") {
          dispatch(
            errorFunc({
              error: resp.response.data,
              status: resp.response.status
            })
          );
        } else {
          dispatch(errorFunc({ ...resp.response.data, status: resp.response.status }));
        }

        return true;
      }
    );
  };
}
